<template>
  <v-dialog v-model="dialog" width="500">
    <v-card>
      <v-card-title>
        <v-layout>
          <v-flex> Upload Images </v-flex>
          <v-flex text-right>
            <v-btn icon @click="cancel">
              <v-icon> mdi-close </v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-layout class="mx-5 pb-6">
        <v-flex>
          <v-layout class="mt-3">
            <v-flex>
              <div class="subtitle-2 mb-1">Select Entity</div>
              <v-autocomplete
                :loading="loading"
                v-model="entity"
                :items="reviewedEntities"
                cache-items
                :search-input.sync="searchTerm"
                hide-details
                return-object
                item-text="title"
                item-value="title"
                placeholder="Select Entity"
                no-data-text="Type a name of an entity to search"
                outlined
                chips
                dense
              ></v-autocomplete>
            </v-flex>
          </v-layout>

          <image-upload-section
            ref="imageUploadSectionRef"
            @selectedImage="selectedImage"
          />
        </v-flex>
      </v-layout>
      <v-card-actions>
        <v-spacer />
        <v-btn
          @click="cancel"
          color="error"
          class="text-none subtitle-2"
          outlined
        >
          Cancel
        </v-btn>
        <v-btn color="primary" class="text-none subtitle-2" @click="save">
          Upload
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ImageUploadSection from "./ImageUploadSection.vue";
import { mapActions, mapState } from "vuex";
import _ from "lodash";
export default {
  components: { ImageUploadSection },
  data() {
    return {
      searchTerm: "",
      dialog: false,
      loading: false,
      selectedImages: [],
      firebaseUrl: "",
      imageThumbnail: "",
      imageUrl: "",
      entity: "",
    };
  },
  computed: {
    ...mapState("$_entity", ["reviewedEntities"]),
    changeFields() {
      return {
        image: {
          firebaseUrl: this.firebaseUrl,
          thumbnail: this.imageThumbnail,
          url: this.imageUrl,
        },

        entity: this.entity,
      };
    },
  },
  watch: {
    searchTerm: _.debounce(function (e) {
      e && this.searchEntities(e);
    }, 300),
  },
  methods: {
    ...mapActions({
      createNewAsset: "$_assets/createNewAsset",
      uploadImage: "$_assets/uploadImage",
      getAssets: "$_assets/getAssets",
      searchEntitiesAction: "$_entity/searchContent",
    }),
    searchEntities(searchTerm) {
      this.loading = true;
      console.log("searching Tags: ", searchTerm);

      this.searchEntitiesAction({
        collection: "entities",
        mutation: "updateReviewedEntities",
        searchTerm: searchTerm,
      }).then(() => {
        this.loading = false;
      });
    },
    selectedImage(images) {
      this.selectedImages = images;
    },
    cancel() {
      this.selectedImages = [];

      this.entity = "";
      this.firebaseUrl = "";
      this.imageThumbnail = "";
      this.imageUrl = "";
      this.$refs.imageUploadSectionRef.resetImages();
      this.dialog = false;
    },
    save() {
      var vm = this;
      var itemsProcessed = 0;
      function callback() {
        vm.getAssets();
        vm.cancel();
      }
      console.log(this.selectedImages);
      this.selectedImages.forEach((image, index) => {
        console.log(image);
        this.uploadImage({ image: image.file, index: index }).then((res) => {
          this.firebaseUrl = res.firebaseUrl;
          this.imageUrl = `https://deetz-biscuit.imgix.net/${res.fileName}?ar=1%3A1&fit=crop&auto=compress&h=700`;
          this.imageThumbnail = `https://deetz-biscuit.imgix.net/${res.fileName}?ar=1%3A1&fit=crop&auto=compress&h=70`;

          this.createNewAsset({ details: this.changeFields }).then(() => {
            itemsProcessed++;
            if (itemsProcessed === this.selectedImages.length) {
              callback();
            }
          });
        });
      });
    },
    toggleDialog() {
      this.dialog = !this.dialog;
    },
  },
};
</script>

<style>
</style>